'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
// import aos from './modules/aos.js';

document.addEventListener('DOMContentLoaded', () => {
    // aos();
});
